'use strict';

exports.__esModule = true;

var _request = require('../constants/request');

var _responseToObject = require('./responseToObject');

var _responseToObject2 = _interopRequireDefault(_responseToObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchFulfill = function fetchFulfill(state, action) {
  return state.merge(_request.REJECTED).setIn(['reason'], action.reason).setIn(['meta'], action.request.meta).setIn(['meta', 'response'], (0, _responseToObject2.default)(action.request.meta.response)).setIn(['meta', 'status'], action.request.meta.response && action.request.meta.response.status);
};

exports.default = fetchFulfill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-fetch/lib/utils/fetchReject.js
// module id = 152
// module chunks = 0